import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, FlexBox, Paper, styled } from 'ml-rubiks-styleguide';
import { CardHeader } from './card-header';
import { Footer } from './footer';
const PageRoot = styled(FlexBox)(({ theme }) => ({
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default ?? theme.palette.grey[100]
}));
export function Layout({ children }) {
    return (_jsxs(PageRoot, { stack: true, children: [_jsx(FlexBox, { stack: true, component: "main", stretch: true, hAlign: "center", sx: {
                    p: { xs: 2, sm: 3 },
                    pt: { xs: 3, sm: 4 }
                }, children: _jsxs(Paper, { elevation: 1, sx: {
                        width: '100%',
                        maxWidth: 800,
                        borderRadius: 2,
                        overflow: 'hidden'
                    }, children: [_jsx(CardHeader, {}), _jsx(Divider, {}), children] }) }), _jsx(Footer, {})] }));
}
